var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvailabilityIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "37px",
  height: "32px",
  viewBox: "0 0 37 32",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "74146678-DF2F-4DA4-8276-ECD934D31B22") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  transform: "translate(-35.000000, -733.000000)",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(17.000000, 714.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Card/\\u03A9Elements/2.-Text-tiles/a.-Headline-6+Avatar+Body-2/_Light-Copy",
  transform: "translate(19.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(0.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.8593478,17.6086957 L28.8593478,1.30434783 C28.8593478,0.586956522 28.2723913,-1.77635684e-14 27.555,-1.77635684e-14 L6.52173913,-1.77635684e-14 C5.80434783,-1.77635684e-14 5.2173913,0.586956522 5.2173913,1.30434783 L5.2173913,26.0869565 C5.2173913,27.5217391 4.04347826,28.6956522 2.60869565,28.6956522 C1.17391304,28.6956522 1.63424829e-13,27.5217391 1.63424829e-13,26.0869565 C1.63424829e-13,24.6521739 1.17391304,23.4782609 2.60869565,23.4782609 L5.2173913,23.4782609",
  id: "Stroke-1"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.2173913,
  y1: 23.4782609,
  x2: 21.0417391,
  y2: 23.4782609,
  id: "Stroke-3"
}), /*#__PURE__*/React.createElement("line", {
  x1: 16.9549565,
  y1: 3.13702174,
  x2: 16.9549565,
  y2: 1.39571739,
  id: "Stroke-5"
}), /*#__PURE__*/React.createElement("line", {
  x1: 16.9549565,
  y1: 14.2405435,
  x2: 16.9549565,
  y2: 4.80097826,
  id: "Stroke-7"
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.8946087,
  y1: 13.2479348,
  x2: 20.3565652,
  y2: 9.06815217,
  id: "Stroke-9"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.75613043,
  y1: 11.5942174,
  x2: 8.49743478,
  y2: 11.5942174,
  id: "Stroke-11"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.4713696,
  y1: 11.5942174,
  x2: 27.2126739,
  y2: 11.5942174,
  id: "Stroke-13"
}), /*#__PURE__*/React.createElement("line", {
  x1: 16.9549565,
  y1: 21.8522609,
  x2: 16.9549565,
  y2: 20.1109565,
  id: "Stroke-15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.8316087,29.8821522 L25.0055217,29.8821522 C23.8968261,29.8821522 23.049,29.0343261 23.049,27.9256304 L23.049,20.0995435 C23.049,18.9908478 23.8968261,18.1430217 25.0055217,18.1430217 L32.8316087,18.1430217 C33.9403043,18.1430217 34.7881304,18.9908478 34.7881304,20.0995435 L34.7881304,27.9256304 C34.7881304,29.0343261 33.875087,29.8821522 32.8316087,29.8821522 Z",
  id: "Stroke-17",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-19",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  points: "25.2988043 24.3135652 27.3857609 26.3353043 32.5379348 21.1831304"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvailabilityIcon);
export default ForwardRef;